//import { Popover } from 'bootstrap';
import tippy from 'tippy.js';
import { isMobile } from '../util/breakpoints';
import copyToClipboard from '../util/clipboard';
import openNativeShare from '../util/nativeShare';
import { qs } from '../util/querySelector';

// the share tooltip is a component in the bstn-blocks plugin, used typically in a hero block
export default function initShareTooltip(options = {}) {
  let opts = Object.assign({
    hoverTooltipClass: 'share-tooltip--hover',
    clickTooltipClass: 'share-tooltip--click',
  }, options);
  const tooltipTriggerEl = qs`.share-tooltip[data-share-tooltip-trigger]`;
  let shareOptionsTemplateEl = qs`.share-tooltip [data-share-tooltip-share-options-template]`;

  if (!tooltipTriggerEl || !shareOptionsTemplateEl) {
    return;
  }

  shareOptionsTemplateEl = shareOptionsTemplateEl.cloneNode(true);
  shareOptionsTemplateEl.removeAttribute('aria-hidden');

  const tooltip = tippy(tooltipTriggerEl, {
    appendTo: () => document.body,  // also the default
    placement: 'top',               // also the default
    offset: [0, 8],
    interactive: true,
    content: 'Share',
    theme: opts.hoverTooltipClass,
  });
  const popover = tippy(tooltipTriggerEl, {
    trigger: 'manual',
    appendTo: () => document.body,  // also the default
    placement: 'top',               // also the default
    offset: [0, 8],
    interactive: true,
    content: shareOptionsTemplateEl,
    html: true, // this isn't strictly necessary when 'content' is an element object
    theme: opts.clickTooltipClass,
  });

  tooltipTriggerEl.addEventListener('mouseenter', () => {
    if (tooltipTriggerEl.classList.contains('is-showing-share-options') || isMobile()) {
      return;
    }

    tooltip.show();
  });
  tooltipTriggerEl.addEventListener('mouseleave', () => {
    tooltip.hide();
  });
  tooltipTriggerEl.addEventListener('click', () => {
    if (isMobile()) {
      let shareData = {
        url: qs`link[rel=canonical]` ? qs`link[rel=canonical]`.href : document.location.href,
      };

      openNativeShare(shareData)
        .catch(e => {
          console.error(e);

          // fallback to copying the article link to the clipboard
          copyToClipboard(window.location.href);
        });

      return;
    }

    tooltipTriggerEl.classList.add('is-showing-share-options');
    popover.show();
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-share-tooltip-trigger]')) {
      popover.hide();
      tooltipTriggerEl.classList.remove('is-showing-share-options');
    }
  });

  // search for the copy link trigger in the cloned options template and bind functionality
  const copyLinkTriggerEl = shareOptionsTemplateEl.querySelector('[data-share-tooltip-copy-link]');

  if (copyLinkTriggerEl) {
    copyLinkTriggerEl.addEventListener('click', () => copyToClipboard(window.location.href));
  }

  // update links for all the social share options
  const socialShareLinks = shareOptionsTemplateEl.querySelectorAll('[data-share-tooltip-link]');

  socialShareLinks.forEach(link => {
    link.setAttribute('href', link.getAttribute('href').replace('%s', encodeURIComponent(window.location.href)));
  });
}
